module.exports = __webpack_public_path__ + "static/20191115_095757-dd41737af5dbaf46637bd6a83ff55416.webp";